import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { Button, Modal } from 'react-bootstrap';
import Fa from 'react-fontawesome';
import { findIndex, each, reduce } from 'lodash';
import ProgressBar from '../../../../components/progress-bar';
import ConfirmButton from '../../../../components/confirm-button';
// Import Actions
import {
  requestFetchDoNotContactFields,
  requestUpdateDoNotContactFields,
} from '../../SetupActions';
import Field from './Field';
import FieldModal from './FieldModal';
import CRMInstanceName from '../../../../components/crm-instance-name';

// Import Selectors

class DoNotContact extends Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      loaded: false,
      fields: [],
      showModal: false,
      saving: false,
      showWarning: false,
    };
    this.loadCustomFields = this.loadCustomFields.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.selectField = this.selectField.bind(this);
    this.handleFieldValueSelected = this.handleFieldValueSelected.bind(this);
    this.handleRemoveField = this.handleRemoveField.bind(this);
    this.save = this.save.bind(this);
    this.submit = this.submit.bind(this);
  }

  componentDidMount() {
    this.loadCustomFields();
  }

  toggleModal() {
    this.setState({ showModal: !this.state.showModal });
  }
  hideModal() {
    this.setState({ showModal: false });
  }

  handleFieldValueSelected(field, selectedValues) {
    const idx = findIndex(this.state.fields, { _id: field._id });
    if (idx >= 0) {
      const newFields = [...this.state.fields];
      newFields[idx] = {
        ...field,
        selectedValues,
      };
      this.setState({ fields: newFields });
    }
  }

  handleRemoveField(field) {
    const idx = findIndex(this.state.fields, { _id: field._id });
    if (idx >= 0) {
      const newFields = [...this.state.fields];
      newFields[idx] = {
        ...field,
        is_do_not_contact_field: false,
        selectedValues: [],
      };
      this.setState({ fields: newFields });
    }
  }

  submit() {
    const { fields } = this.state;
    const toSave = reduce(fields, (items, field) => {
      if (field.is_do_not_contact_field && field.selectedValues && field.selectedValues.length) {
        items.push({
          name: field.name,
          values: field.selectedValues,
        });
      }
      return items;
    }, []);
    this.setState({ showWarning: false, saving: true });
    return new Promise((resolve, reject) => {
      this.props.dispatch(requestUpdateDoNotContactFields({ do_not_contact_fields: toSave }))
        .then(
          (results) => {
            this.setState({
              saving: false,
              fields: results.fields,
            }, () => {
              resolve(results);
            });
          },
          (e) => {
            this.setState({ saving: false }, () => {
              reject(e);
            });
          },
        );
    });
  }

  save() {
    this.setState({ showWarning: true });
  }

  selectField(field) {
    const idx = findIndex(this.state.fields, { _id: field._id });
    if (idx >= 0) {
      const newFields = [...this.state.fields];
      const newField = {
        ...field,
        is_do_not_contact_field: true,
      };
      if (newField.type === 'boolean') {
        newField.selectedValues = [true];
      }
      newFields[idx] = newField;
      this.setState({ fields: newFields });
    }
  }

  loadCustomFields() {
    this.setState({
      loading: true, loaded: false, fields: [],
    });
    const allFieldsPromise = this.props.dispatch(requestFetchDoNotContactFields());
    allFieldsPromise.then(
      (results) => {
        const { fields } = results;
        this.setState({
          loading: false,
          loaded: true,
          fields,
        });
      },
      () => {
        this.setState({
          loading: false, loaded: false, fields: [],
        });
      },
    );
    return allFieldsPromise;
  }

  renderWarningModal() {
    const { showWarning } = this.state;
    return (
      <div>
        <Modal key="modal" show={showWarning} onHide={() => { this.setState({ showWarning: false }); }}>
          <Modal.Header closeButton>
            <h4><Fa name="exclamation-triangle" /> Warning</h4>
          </Modal.Header>
          <Modal.Body>
            <div>
              <p>This will require TruVoice Automation to sync to all contacts from <CRMInstanceName /> instance.</p>
              <p>Do you wish to continue?</p>
            </div>
          </Modal.Body>
          <Modal.Footer className="clearfix">
            <Button bsStyle="default" onClick={() => { this.setState({ showWarning: false }); }} className="pull-left">No - Cancel</Button>
            <Button bsStyle="warning" onClick={this.submit} className="pull-right">Yes - Resync All Contacts</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }

  renderInstruction() {
    return (
      <div className="well well-sm">
        <div>
          <p>
            Select a contact field(s) to use to check if a contact should be submitted to the feedback request.
          </p>
          <p>Contacts that match these criteria will <strong>NOT</strong> be submitted.</p>
        </div>
      </div>
    );
  }

  renderInvalidField(field) {
    return (
      <div className="well well-sm" key={field._id}>
        <div className="clearfix">
          <div className="pull-right">
            <ConfirmButton 
              size="xs"
              confirmMessage="?"
              confirmStyle="link"
              onConfirm={() => {
                this.handleRemoveField(field);
              }}
            >
              <Fa name="trash" />
            </ConfirmButton>
          </div>
          <div>
            <Fa name="exclamation-triangle" className="text-danger" /> <code>{field.name}</code> <span className="label label-danger text-uppercase">inaccessible field</span>
          </div>
        </div>
        
      </div>
    );
  }

  renderContent() {
    const {
      fields, showModal,
      saving,
    } = this.state;
    if (fields.length === 0) {
      return (
        <div className="alert alert-warning">No fields found</div>
      );
    }
    const selectedFields = [];
    const availableFields = [];
    each(fields, (field) => {
      if (field.is_do_not_contact_field) {
        selectedFields.push(field);
      } else {
        availableFields.push(field);
      }
    });
    const addBtn = (<Button disabled={saving} bsStyle="link" active={showModal} className="pull-left" onClick={this.toggleModal}><Fa name="plus" /> Add Field</Button>);
    return (
      <div>
        {selectedFields.length === 0 && <div className="well clearfix"><p>No fields found.</p>{addBtn}</div>}
        
        {selectedFields.map((field) => {
          if (field.accessible === false) {
            return this.renderInvalidField(field)
          }
          return (
            <Field disabled={saving} key={field._id} field={field} onRemoveField={this.handleRemoveField} onSelected={this.handleFieldValueSelected} />
          );
        })}
        
        
        <div className="clearfix" style={{ paddingTop: '10px' }}>
          {availableFields.length > 0 && selectedFields.length > 0 && addBtn}
          <Button onClick={this.save} disabled={saving} className="pull-right" bsStyle="primary">
            {!saving && <span><Fa name="check" /> Save</span>}
            {saving && <span><Fa name="spinner" spin /> Saving</span>}
          </Button>
        </div>
        <FieldModal
          fields={availableFields}
          show={showModal}
          onClose={() => { this.setState({ showModal: false }); }}
          onSelect={this.selectField}
        />
        {this.renderWarningModal()}
      </div>
    );
  }

  render() {
    const { loading, loaded } = this.state;
    return (
      <div>
        <Helmet title="Setup Do Not Contact Fields" />
        <div className="container">
          {this.renderInstruction()}
          {loading && <ProgressBar />}
          {!loading && loaded && this.renderContent()}
        </div>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps() {
  return {
  };
}

DoNotContact.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

DoNotContact.contextTypes = {
};

export default connect(mapStateToProps)(DoNotContact);
